<template>
  <div
    :class="['container-vs-input-number', { disabled }]"
  >
    <div class="overlay"/>
    <vs-input-number
      v-model="input"
      v-bind="$attrs"
      :disabled="disabled"
      v-on="$listeners"
    />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      input: null,
    }
  },

  watch: {
    input () {
      this.$emit('input', this.input)
    },
    value () {
      this.input = this.value
    },
  },

  created () {
    this.input = this.value
  },
}
</script>

<style scoped>
.container-vs-input-number {
  position: relative;
}

.container-vs-input-number.disabled .overlay {
  display: block;
}

.container-vs-input-number.disabled .vs-input-number {
  background-color: #e9ecef;
}

.overlay {
  display: none;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseVsInputNumber.vue